import { dbService } from './dbService.js';

class SettingsService {
  async getSettings() {
    const defaults = {
      currency: 'AUD',
      financialYearStart: '07-01',
      importantCategories: [],
      dateFormat: 'system',
      backupFolder: null,
      lastBackup: null,
      autoBackup: true,
      autoBackupInterval: 15, // minutes
      categorizationRules: [],
      budgetWarningPercent: 80,
    };

    try {
      const settings = {};
      for (const [key, defaultValue] of Object.entries(defaults)) {
        const setting = await dbService.getSetting(key);
        // dbService.getSetting already unwraps the stored {key,value} record.
        // Preserve false/0 and arrays rather than replacing them with defaults.
        settings[key] = setting === undefined ? defaultValue : setting;
      }
      return settings;
    } catch (error) {
      console.error('Failed to load settings:', error);
      return defaults;
    }
  }

  async setSetting(key, value) {
    try {
      await dbService.setSetting(key, value);
      return true;
    } catch (error) {
      console.error('Failed to save setting:', error);
      return false;
    }
  }

  async updateSettings(updates) {
    try {
      for (const [key, value] of Object.entries(updates)) {
        await this.setSetting(key, value);
      }
      return true;
    } catch (error) {
      console.error('Failed to update settings:', error);
      return false;
    }
  }
}

export const settingsService = new SettingsService();